import React, { useEffect, useState } from 'react'
import ValoresCupos from './ValoresCupos'
import { Col, Row } from 'react-bootstrap'
import { connect } from 'react-redux'
import moment from 'moment'
import ValoresCircuito from './ValoresCircuito'
import CardValores from './CardValores'
import ValoresEmbarque from './ValoresEmbarque'

function EstadoElevador (props) {
  const { totalizadorCupos, cdmdTotales } = props
  const [asignados, setAsignados] = useState(0)
  const [descargados, setDescargados] = useState(0)
  const [circuito, setCircuito] = useState(null)

  useEffect(() => {
    const hoy = moment(new Date()).format('YYYY-MM-DD')
    if (totalizadorCupos && totalizadorCupos.length > 0) {
      const cantidadAsignados = totalizadorCupos.filter((t) => t.fechaDeEmision === hoy)
      console.log('cantidad asignados ', cantidadAsignados)
      setAsignados(cantidadAsignados ? cantidadAsignados[0].cantidadAsignada : 0)
    }
    if (cdmdTotales && cdmdTotales[0]) {
      setDescargados(cdmdTotales[0].descargados)

      // const circuitoCantidades = [
      //   {
      //     titulo: 'En playa',
      //     cantidad: cdmdTotales[0].ingresoCompleto
      //   },
      //   {
      //     titulo: 'Entre playa y calado',
      //     cantidad: cdmdTotales[0].entrePlayaYCalado
      //   },
      //   {
      //     titulo: 'Calados autorizados',
      //     cantidad: cdmdTotales[0].caladoSinPesarAutorizados
      //   },
      //   {
      //     titulo: 'Calados pendientes',
      //     cantidad: cdmdTotales[0].caladoSinPesarPendientes
      //   },
      //   {
      //     titulo: 'Listos para bruto',
      //     cantidad: cdmdTotales[0].entreCaladoYBruto
      //   },
      //   {
      //     titulo: 'Entre bruto y destare',
      //     cantidad: cdmdTotales[0].entreBrutoYDestare
      //   },
      //   {
      //     titulo: 'Descargados',
      //     cantidad: cdmdTotales[0].descargados
      //   },
      //   {
      //     titulo: 'Total',
      //     cantidad: cdmdTotales[0].total
      //   }
      // ]

      const cantAgrupadas = [
        {
          titulo: 'Sin calar',
          cantidad: cdmdTotales[0].entrePlayaYCalado + cdmdTotales[0].ingresoCompleto
        },
        {
          titulo: 'Calados',
          cantidad: cdmdTotales[0].caladoSinPesarAutorizados + cdmdTotales[0].entreCaladoYBruto
        },
        {
          titulo: 'Con peso bruto',
          cantidad: cdmdTotales[0].entreBrutoYDestare
        },
        {
          titulo: 'Descargados',
          cantidad: cdmdTotales[0].descargados
        }
      ]

      setCircuito(cantAgrupadas)
    }
  }, [totalizadorCupos, cdmdTotales])

  return (
    <>
      <Row>
        <Col md={3}>
          <ValoresCupos asignados={asignados} descargados={descargados} />
          <CardValores
            titulo={'Buques anunciados'}
            cantidad={'000'}
            // porcentaje={}
            cardColor={'#4e5789'}
          />
        </Col>

        <Col md={6}>
          <ValoresCircuito circuito={circuito} />
        </Col>

        <Col md={3}>
          <CardValores
            titulo={'Stock en terminal'}
            cantidad={'000'}
            // porcentaje={}
            cardColor={'#4e5789'}
          />
          <CardValores
            titulo={'Stock en terminal'}
            cantidad={'000'}
            // porcentaje={}
            cardColor={'#4e5789'}
          />
        </Col>
      </Row>
      <Row>
        <ValoresEmbarque />

        <Col md={3}>
          <CardValores
            titulo={'Buques anunciados'}
            cantidad={'000'}
            // porcentaje={}
            cardColor={'#4e5789'}
          />
        </Col>

      </Row>
    </>
  )
}
const mapStateToProps = (state) => ({
  cdmdTotales: state.dashboard.cdmdTotales,
  existenciaDiaria: state.dashboard.existenciaDiaria,
  totalizadorCupos: state.cupos.totalizadorCupos,
  totalStock: state.stock.totalStock
})

const withRedux = connect(mapStateToProps, null)
export default withRedux(EstadoElevador)
